import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const setupDayjs = () => {
	dayjs.extend(relativeTime);
	dayjs.extend(localizedFormat);
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(duration);
	dayjs.extend(customParseFormat);
	dayjs.extend(advancedFormat);
};
